import { Component, OnInit, HostListener } from "@angular/core";
import { AppService } from "../services/app.service";
import { HttpService } from "../services/http.service";
import { ActivatedRoute, Router } from "@angular/router";
import { AlertController } from "@ionic/angular";
import { Title } from "@angular/platform-browser";

import { Location } from "@angular/common";
import { AmplifyService } from "../services/amplify.service";

//APPSYNC
import { SyncService } from "../services/sync.service";
import { Observable, ZenObservable } from "zen-observable-ts";

@Component({
  selector: "app-devices",
  templateUrl: "./devices.page.html",
  styleUrls: ["./devices.page.scss"],
})
export class DevicesPage implements OnInit {
  //APPSYNC
  subscription: ZenObservable.Subscription;
  session: any;

  flags: any;
  public isColumnVisible = true;

  @HostListener("window:resize", ["$event"])
  onResize(event) {
    this.checkScreenSize();
  }

  constructor(
    public app: AppService,
    public sync: SyncService,
    public amplify: AmplifyService,
    public http: HttpService,
    private location: Location,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    public alertController: AlertController,
    public title: Title
  ) {
    this.checkScreenSize();
    this.flags = {
      fontList: [
        "Verdana",
        "Georgia",
        "Arial",
        "Serif",
        "Sans-Serif",
        "Times New Roman",
        "Candara",
        "Calibri",
        "Optima",
        "Lucida Bright",
        "Cera GR Light",
        "Cera GR Medium",
        "Cera GR Bold",
        "Typold Regular",
        "Typold Medium",
        "Typold Extra Bold",
        "Proxima Nova",
        "Proxima Nova Bold",
        "Montserrat Thin",
        "Montserrat Regular",
        "Montserrat Medium",
        "Montserrat Bold",
        "Montserrat Extra Bold",
        "Roboto Light",
        "Roboto Regular",
        "Roboto Medium",
        "Roboto Bold",
        "Open Sans Regular",
        "Open Sans Light",
        "Open Sans Semi Bold",
        "Open Sans Bold",
      ],
      fontSizeList: [
        8, 10, 12, 14, 16, 18, 20, 22, 24, 26, 28, 30, 32, 34, 36, 38, 40, 42, 44, 46, 48, 50, 52, 54, 56, 58, 60, 65,
        70, 75, 80, 85, 90, 95, 100,
      ],

      used_device_licenses: null,
      total_device_licenses: null,

      modalMode: null,

      editDevice: null,

      deviceList: [],
      deviceResults: [],

      siteList: [],

      activation: null,
      activationPass: null,

      defaultDevice: {
        company_id: null,
        site_ids: null,
        site_settings: [],
        token: null,
        type: "kiosk",
        name: null,
        status: "activate",
        checkin_epoch: null,
        player_version: null,
        server_version: null,
        data: null,
        settings: {
          links: [],
          selectionTitle: "",
          selectionTitleColor: "#333",
          selectionTitleFont: "Verdana",
          selectionTitleSize: "20",
          selectionCaption: "",
          selectionCaptionColor: "#333",
          selectionCaptionFont: "Verdana",
          selectionCaptionSize: "20",
          x: 0,
          y: 0,
          scaleX: 1,
          scaleY: 1,
          rotate: 0,
          ariiFooter: true,
          apSEOTitle: "",
          apSEODesc: "",

          bgImage: null,
          bgColor: "#ffffff",
          wImage: null,
          wImageLoop: null,
          wVideo: null,
        },
      },
    };

    //this.flags.editDevice = JSON.parse(JSON.stringify(this.flags.defaultDevice));
  }

  ionViewDidEnter() {
    this.getData(null);
    this.getSites();
  }

  validateToken(value: string): void {
    // Regular expression that matches characters allowed in a URL
    const validChars = /^[A-Za-z0-9\-._~:/?#\[\]@!$&'()*+,;=]*$/;

    if (!validChars.test(value)) {
      // Remove invalid characters
      this.app.toast("Invalid character was removed", "warning");
      this.flags.editDevice.token = value.replace(/[^A-Za-z0-9\-._~:/?#\[\]@!$&'()*+,;=]/g, "");
    }
  }

  checkScreenSize() {
    // This ensures that on larger screens, the visibility is handled automatically,
    // but on smaller screens, the column remains visible unless toggled.
    if (window.innerWidth >= 768) {
      this.isColumnVisible = true; // Always visible on larger screens
    } else {
      // Do not automatically hide on mobile; respect the current toggle state
      // Remove or comment out this line if you want it always visible when reloading the page on mobile:
      // this.isColumnVisible = false;
    }
  }

  toggleColumn() {
    if (window.innerWidth < 768) {
      // Change 768 to your desired breakpoint for smaller screens
      this.isColumnVisible = !this.isColumnVisible;
    }
  }

  addLink() {
    var obj = {
      id: Date.now(),
      name: "",
      target: null,
      textColor: "#333",
      textFont: "Verdana",
      textSize: "20",
      bgColor: "#efefef",
      bgImage: null,
      width: "98%",
    };
    this.flags.editDevice.settings.links.push(obj);
  }

  removeLink(i) {
    this.flags.editDevice.settings.links.splice(i, 1); //support contacts
  }

  saveDesign(m) {
    console.log("SAVING MODAL " + m, this.flags.modalItem);
    //save link entries
    if (m == 2) {
      var i = this.flags.editDevice.settings.links.findIndex((el) => el.id === this.flags.modalItem.id);
      var obj = JSON.parse(JSON.stringify(this.flags.modalItem));
      this.flags.editDevice.settings.links[i] = obj;

      this.closeModal();
    }
  }

  reorderSetting(m, e) {
    if (m == 0) {
      // reorder client button element
      let draggedItem = this.flags.editDevice.settings.links.splice(e.detail.from, 1)[0];
      this.flags.editDevice.settings.links.splice(e.detail.to, 0, draggedItem);
      e.detail.complete();
    }

    if (m == 4) {
      let draggedItem = this.flags.editDevice.site_ids.splice(e.detail.from, 1)[0];
      this.flags.editDevice.site_ids.splice(e.detail.to, 0, draggedItem);
      e.detail.complete();
      this.refreshSites();
    }
  }

  openModal(m, item) {
    this.flags.modalMode = m;
    this.flags.modalItem = JSON.parse(JSON.stringify(item));
  }

  closeModal() {
    this.flags.modalMode = null; //clear modal flag
  }

  refreshSites() {
    if (this.flags.editDevice.site_ids.length) {
      var arr1: any = [];
      var arr2 = JSON.parse(JSON.stringify(this.flags.editDevice.site_settings));

      for (var i in this.flags.editDevice.site_ids) {
        arr1.push({
          id: this.flags.editDevice.site_ids[i],
          phone: true,
          sms: true,
          email: true,
          chat: true,
          videochat: true,
          audiochat: true,
          facebook: true,
          whatsapp: true,
          shareButton: true,
        });
      }

      for (var i in arr1) {
        const match = arr2.find((item2) => item2.id === arr1[i].id);
        if (match) {
          arr1[i] = match;
        }
      }

      this.flags.editDevice.site_settings = JSON.parse(JSON.stringify(arr1));
    }
  }

  saveDevice(m) {
    if (m == 1) {
      //SAVE NEW DEVICE
      var obj = this.flags.editDevice;
      obj.server_version = Date.now();
      obj.site_ids = JSON.stringify(obj.site_ids);
      obj.site_settings = JSON.stringify(obj.site_settings);
      obj.settings = JSON.stringify(obj.settings);

      console.log("SAVING NEW", obj);

      this.http
        .apiPost("devices", { data: obj }, null)
        .then((data) => {
          //this.app.toast('Company Saved', 'success');
          //this.getAccess();
          this.app.toast("Device has been added to your account", "success");
          //this.reset();
          this.getData(data.data.insertId);
        })
        .catch((err) => {
          //this.navCtrl.navigateRoot('/account');
          this.app.alert("Could update account, Please try again later or contact us");
        });
    }

    if (m == 1.1) {
      var obj = JSON.parse(JSON.stringify(this.flags.editDevice));
      obj.server_version = Date.now();
      obj.site_ids = JSON.stringify(obj.site_ids);
      obj.site_settings = JSON.stringify(obj.site_settings);
      obj.settings = JSON.stringify(obj.settings);
      console.log("SAVING EXISTING", obj);

      this.http
        .apiPut("devices/id/" + obj.id, { data: obj }, null)
        .then((data) => {
          this.app.toast("Device updates saved", "success");
          //this.getAccess();
          //this.reset();
          this.getData(obj.id);
        })
        .catch((err) => {
          //this.navCtrl.navigateRoot('/account');
          this.app.alert("Could update account, Please try again later or contact us");
        });
    }
  }

  getData(id) {
    this.flags.editDevice = null;
    //'?join=company_slides,slide_id,id,name:src:type&orderby=priority+asc'
    this.http.apiGet("devices/company_id/" + this.app.sysData.company_id + "?orderby=name", null).then((data) => {
      console.log("get devices", data.data);
      var obj = data.data;

      this.flags.used_device_licenses = obj.length; //current licenses being used
      var temp = this.app.sysData.userAccess.find((el) => el.id === this.app.sysData.company_id); //find returns a single item with match
      this.flags.total_device_licenses = temp.device_licenses;

      this.flags.deviceList = obj;
      this.flags.deviceResults = obj;

      if (id) {
        //if id is passed, then edit that device by id
        var temp = this.flags.deviceList.find((el) => el.id === id); //find returns a single item with match
        this.editDevice(1.1, temp);
      }
    });
  }

  getSites() {
    //'?join=company_slides,slide_id,id,name:src:type&orderby=priority+asc'
    this.http.apiGet("company_sites/company_id/" + this.app.sysData.company_id, null).then((data) => {
      console.log("get sites", data.data);
      var obj = data.data;

      this.flags.siteList = obj;
    });
  }

  deleteDevice() {
    var id = this.flags.editDevice.id;
    this.http.apiDelete("devices/id/" + id, null).then((data) => {
      this.app.presentToast("Device Removed", "success");
      //this.getFolders();
      this.reset();
    });
  }

  editDevice(m, params) {
    //this.flags.modalMode = m;

    if (m == 1) {
      var obj = JSON.parse(JSON.stringify(this.flags.defaultDevice));
      obj.company_id = this.app.sysData.company_id;
      this.flags.editDevice = obj;
    }

    if (m == 1.1) {
      //CONNECT TO THIS DEVICE
      var obj = JSON.parse(JSON.stringify(params));
      obj.settings = JSON.parse(obj.settings);
      obj.site_ids = JSON.parse(obj.site_ids);
      obj.site_settings = JSON.parse(obj.site_settings);

      this.flags.editDevice = obj;

      //this.subscribe();
    }
  }

  reset() {
    this.flags.editDevice = null; //{id: null};
    this.getData(null);
  }

  uploadFile(m, files, i) {
    console.log("File upload 0", files);
    //this.app.alert('coming soon');
    //ACL: 'private'
    //ACL: 'public-read'
    //ACL: 'public-read-write'

    this.amplify
      .uploadFile(files, "public-read")
      .then((data) => {
        console.log("file uploaded", data);

        if (m == 1) {
          //upload to repo
          this.flags.editDevice.settings.bgImage = this.app.sysData.s3Root + data["key"];
        }

        if (m == 2) {
          //upload to site selector
          this.flags.editDevice.settings.logoIcon = this.app.sysData.s3Root + data["key"];
        }

        if (m == 3) {
          //upload to custom link
          this.flags.modalItem.bgImage = this.app.sysData.s3Root + data["key"];
        }

        if (m == 4) {
          //upload to welvome video
          this.flags.editDevice.settings.wVideo = this.app.sysData.s3Root + data["key"];
        }

        if (m == 5) {
          //upload to welvome image
          this.flags.editDevice.settings.wImage = this.app.sysData.s3Root + data["key"];
          if (this.flags.editDevice.settings.wImageLoop == null) {
            this.flags.editDevice.settings.wImageLoop = 0;
          }
        }
        //this.flags.profileFocusData.ext = data['ext'];
        this.app.toast("File Uploaded", "success");
      })
      .catch((err) => {
        this.app.alert("Error | " + JSON.stringify(err));
        console.log("Error", err);
      });
  }

  ngOnInit() {
    this.title.setTitle("Access Points");
  }

  async presentAlertConfirm(m, i) {
    const alert = await this.alertController.create({
      header: "Are you sure?",
      message: "This cannot be undone",
      buttons: [
        {
          text: "Cancel",
          role: "cancel",
          cssClass: "secondary",
          handler: (blah) => {
            console.log("Confirm Cancel: blah");
          },
        },
        {
          text: "Okay",
          handler: () => {
            if (m == 2) {
              this.removeLink(i);
            }

            if (m == 1) {
              this.deleteDevice();
            }
            console.log("Confirm Okay");
          },
        },
      ],
    });

    await alert.present();
  }
}
